import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  OnDestroy,
  ChangeDetectorRef,
  Inject,
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { SessionService } from '@app/session/session.service';
import { WindowToken } from '@app/shared/window.token';

@Component({
  selector: 'dgx-session-timeout-modal',
  templateUrl: './session-timeout-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SessionTimeoutModalComponent implements OnInit, OnDestroy {
  public bodyText: string;
  public buttonText: string;
  private updateTimer: number;

  constructor(
    private translateService: TranslateService,
    private sessionService: SessionService,
    private activeModal: NgbActiveModal,
    private cdr: ChangeDetectorRef,
    @Inject(WindowToken) private windowRef: Window
  ) {}

  public ngOnInit(): void {
    this.buttonText = this.translateService.instant(
      'SessionTimeoutModal_StillHere'
    );
    this.updateBodyText();
  }

  public ngOnDestroy(): void {
    this.windowRef.clearTimeout(this.updateTimer);
  }

  public close(): void {
    this.activeModal.close();
  }

  private updateBodyText(): void {
    const sessionTimeout = this.sessionService.expiration
      ? this.sessionService.sessionTimeout
      : 0;

    // A background request might have extended the session so we just close the modal.
    if (sessionTimeout > this.sessionService.modalTimeout) {
      return this.close();
    }

    // Update countdown text
    this.bodyText = this.translateService.instant('SessionTimeoutModal_Body', {
      secondsRemaining: sessionTimeout,
    });

    this.updateTimer = this.windowRef.setTimeout(() => {
      this.updateBodyText();
    }, 1000);

    this.cdr.markForCheck();
  }
}
